import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          this.authenticationService.logout();
        }
        if (err instanceof HttpErrorResponse) {
          if ((err.status === 400 || err.status === 403 || err.status == 500)) {
            let message = 'Ошибка!';
            const error = err.error;
            if (error.message) {
              message = error.message;
            }
            else {
              if (typeof error == 'object') {
                if (Object.prototype.hasOwnProperty.call(error, 'errors')) {
                  const errors = error['errors'];
                  for (const key in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, key)) {
                      const element = errors[key];
                      message += ' ' + element;
                    }
                  }
                }
                else if (Object.prototype.hasOwnProperty.call(error, 'error')) {
                  const err = error.error;
                  if (typeof err == 'object') {
                    message = err['message'] ?? 'Ошибка в сервер';
                  }
                  else if (typeof err === 'string') {
                    message = err;
                  }
                }
                else{
                  message='Ошибка в сервер!'
                }

              }
              else if (typeof error === 'string') {
                message = error;
              }
              else if (error.message) {
                message = error.message;
              }
            }
            return throwError(() => new Error(message));
          }
          else if (err.status == 500) {
            return throwError(() => new Error(err.message ?? err.error ?? 'Ошибка в сервер'));
          }
          else {
            //const error = err.error?.message || err.statusText;
            const myerr = new Error(err.message);
            return throwError(() => myerr);
          }
        }
        else {
          console.log('Нестандартная ошибка');
          return throwError(() => err);
        }
      })
    );
  }
}
